import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=2553a585&scoped=true"
import script from "./Terminal.vue?vue&type=script&lang=js"
export * from "./Terminal.vue?vue&type=script&lang=js"
import style0 from "./Terminal.vue?vue&type=style&index=0&id=2553a585&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553a585",
  null
  
)

export default component.exports